import React, { useEffect, useState } from "react";
import { getBusinessReportByMonth, downloadBusinessReportByMonthCSV } from "../../../actions/report";
import { Card, DatePicker, Table, Skeleton, Space,Breadcrumb, Divider, Button } from "antd";
import { DownloadOutlined } from '@ant-design/icons';
import moment from "moment";

const BusinessReportByMonth = () => {
  const [dailyData, setDailyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(moment());
  
  var formatter = new Intl.NumberFormat("en-IN");

  useEffect(() => {
    fetchReport();
  }, [selectedMonth]);

  const fetchReport = () => {
    setLoading(true);
    const start = moment(selectedMonth).startOf('month').format("YYYY-MM-DD");
    const end = moment(selectedMonth).endOf('month').format("YYYY-MM-DD");
    
    console.log("Fetching report for:", start, "to", end);
    console.log("Fetching report for:", start, "to", end);
    getBusinessReportByMonth(start, end)
      .then((res) => {
        console.log("API Response:", res);
        if (res && res.data) {
          console.log("Data received:", res.data);
          console.log("Number of days:", res.data.length);
          
          // Transform the data for the table
          const tableData = res.data.map((day, index) => {
            const row = {
              key: index,
              date: day.date,
            };
            
            // Add all metrics dynamically
            day.metrics.forEach(metric => {
              row[metric.name] = metric.amount;
            });
            
            return row;
          });
          console.log("Transformed table data:", tableData);
          setDailyData(tableData);
        } else {
          console.log("No data in response");
          setDailyData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching report:", error);
        setDailyData([]);
      })
      .finally(() => setLoading(false));
  };

  const handleMonthChange = (date) => {
    if (date) {
      setSelectedMonth(moment(date));
    }
  };

  const handleDownloadCSV = () => {
    const start = moment(selectedMonth).startOf('month').format("YYYY-MM-DD");
    const end = moment(selectedMonth).endOf('month').format("YYYY-MM-DD");
    downloadBusinessReportByMonthCSV(start, end);
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 120,
      fixed: 'left',
      render: (date) => date === "Total" ? <strong style={{color: '#1890ff'}}>Total</strong> : moment(date).format("DD MMM YYYY"),
    },
    // {
    //   title: "Previous Due",
    //   dataIndex: "Previous Due",
    //   key: "Previous Due",
    //   align: "right",
    //   render: (value) => formatter.format(value || 0),
    // },
    // {
    //   title: "Current Due",
    //   dataIndex: "Current Due",
    //   key: "Current Due",
    //   align: "right",
    //   render: (value) => formatter.format(value || 0),
    // },
    // {
    //   title: "Total Due",
    //   dataIndex: "Total Due",
    //   key: "Total Due",
    //   align: "right",
    //   render: (value) => formatter.format(value || 0),
    // },
    // {
    //   title: "Due collection",
    //   dataIndex: "Due collection",
    //   key: "Due collection",
    //   align: "right",
    //   render: (value) => formatter.format(value || 0),
    // },
    // {
    //   title: "Outstanding",
    //   dataIndex: "Outstanding",
    //   key: "Outstanding",
    //   align: "right",
    //   render: (value) => formatter.format(value || 0),
    // },
    {
      title: "Stock in",
      dataIndex: "Stock In",
      key: "Stock In",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Stock out",
      dataIndex: "Stock Out",
      key: "Stock Out",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Sales revenue",
      dataIndex: "Sell",
      key: "Sell",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Cost of goods sold",
      dataIndex: "COG",
      key: "COG",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Gross profit",
      dataIndex: "Gross Profit",
      key: "Gross Profit",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Operational expenses",
      dataIndex: "Expenses",
      key: "Expenses",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Net profit",
      dataIndex: "Net Profit",
      key: "Net Profit",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Opening balance",
      dataIndex: "Opening balance",
      key: "Opening balance",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    
    {
      title: "Cash",
      dataIndex: "Cash",
      key: "Cash",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "City Bank",
      dataIndex: "City Bank",
      key: "City Bank",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Bkash-1818",
      dataIndex: "Bkash-1818",
      key: "Bkash-1818",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Cash out to office",
      dataIndex: "Cash out to office",
      key: "Cash out to office",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
    {
      title: "Closing balance",
      dataIndex: "Closing balance",
      key: "Closing balance",
      align: "right",
      render: (value) => formatter.format(value || 0),
    },
  ];

  return (
    <>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Business report by month</Breadcrumb.Item>
        </Breadcrumb>
        <div className="site-layout-background main-frame">
          {/* <div style={{ color: '#666', fontSize: '14px', padding: "10px" }}>
            Showing report for: {selectedMonth.format("MMMM YYYY")}
          </div> */}
          <Card style={{ marginBottom: 16 }}>
            <Space size="large">
              <div>
                <label style={{ marginRight: 8, fontWeight: 500 }}>Select Month:</label>
                <DatePicker
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  picker="month"
                  format="YYYY-MM"
                />
              </div>
              <Button type="primary" icon={<DownloadOutlined />} onClick={handleDownloadCSV}>
                Download CSV
              </Button>
            </Space>
          </Card>

          {loading ? (
            <Card>
              <Skeleton active />
            </Card>
          ) : (
            <Card>
            <h3 style={{textAlign: "center"}}>Station - {selectedMonth.format("MMMM YYYY")}</h3>
            <Divider />
              <Table
                columns={columns}
                dataSource={dailyData}
                pagination={false}
                scroll={{ x: 800 }}
                bordered
                size="small"
                // summary={(pageData) => {
                //   let totalPreviousStock = 0;
                //   let totalNewPurchase = 0;
                //   let totalPurchaseReturn = 0;
                //   let totalSales = 0;
                //   let totalCurrentStock = 0;

                //   pageData.forEach(({ previousStock, newPurchase, purchaseReturn, sales, currentStock }) => {
                //     totalPreviousStock += previousStock;
                //     totalNewPurchase += newPurchase;
                //     totalPurchaseReturn += purchaseReturn;
                //     totalSales += sales;
                //     totalCurrentStock += currentStock;
                //   });

                //   return (
                //     <Table.Summary.Row style={{ fontWeight: 'bold', backgroundColor: '#fafafa' }}>
                //       <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                //       <Table.Summary.Cell index={1} align="right">
                //         {formatter.format(totalPreviousStock)}
                //       </Table.Summary.Cell>
                //       <Table.Summary.Cell index={2} align="right">
                //         {formatter.format(totalNewPurchase)}
                //       </Table.Summary.Cell>
                //       <Table.Summary.Cell index={3} align="right">
                //         {formatter.format(totalPurchaseReturn)}
                //       </Table.Summary.Cell>
                //       <Table.Summary.Cell index={4} align="right">
                //         {formatter.format(totalSales)}
                //       </Table.Summary.Cell>
                //       <Table.Summary.Cell index={5} align="right">
                //         {formatter.format(totalCurrentStock)}
                //       </Table.Summary.Cell>
                //     </Table.Summary.Row>
                //   );
                // }}
              />
            </Card>
          )}
        </div>
      

      
    </>
  );
};

export default BusinessReportByMonth;
